// sapi-admin/src/services/cameroonShipping.js
// Géographie uniquement - PLUS AUCUN TARIF HARCODÉ

export const CAMEROON_DATA = {
  regions: {
    'littoral': {
      id: 'littoral',
      name: 'Littoral',
      code: 'LIT',
      days: '7 days',
      departments: {
        'wouri': {
          id: 'wouri',
          name: 'Wouri',
          cities: [
            'Douala I (Akwa)',
            'Douala II (New-Bell)',
            'Douala III (Logbaba)',
            'Douala IV (Bonabéri)',
            'Douala V (Kotto)',
            'Douala VI (Bépanda)',
            'Douala VII (Bonamoussadi)'
          ]
        },
        'moungo': {
          id: 'moungo',
          name: 'Moungo',
          cities: ['Nkongsamba', 'Loum', 'Manjo', 'Melong']
        },
        'nkam': {
          id: 'nkam',
          name: 'Nkam',
          cities: ['Yabassi', 'Bonepoupa', 'Nkondjock']
        }
      }
    },
    'centre': {
      id: 'centre',
      name: 'Centre',
      code: 'CEN',
      days: '7 days',
      departments: {
        'mfoundi': {
          id: 'mfoundi',
          name: 'Mfoundi',
          cities: [
            'Yaoundé I (Lom Pangar)',
            'Yaoundé II (Mokolo)',
            'Yaoundé III (Mvan)',
            'Yaoundé IV (Mvog-Mbi)',
            'Yaoundé V (Nkongsamba)',
            'Yaoundé VI (Etoa-Meki)',
            'Yaoundé VII (Mimboman)'
          ]
        },
        'mefou_afamba': {
          id: 'mefou_afamba',
          name: 'Mefou Afamba',
          cities: ['Mbalmayo', 'Awaé']
        },
        'nyong_kelle': {
          id: 'nyong_kelle',
          name: 'Nyong Kelle',
          cities: ['Mfou', 'Ayos', 'Biyouha']
        }
      }
    },
    'nord_ouest': {
      id: 'nord_ouest',
      name: 'Nord-Ouest',
      code: 'NW',
      days: '7-10 days',
      departments: {
        'momo': {
          id: 'momo',
          name: 'Momo',
          cities: ['Mbengwi', 'Bali', 'Bafanji']
        },
        'bui': {
          id: 'bui',
          name: 'Bui',
          cities: ['Kumbo', 'Nkambé', 'Mbem']
        }
      }
    },
    'sud_ouest': {
      id: 'sud_ouest',
      name: 'Sud-Ouest',
      code: 'SW',
      days: '7-10 days',
      departments: {
        'fako': {
          id: 'fako',
          name: 'Fako',
          cities: ['Buea', 'Limbe', 'Mutengene']
        },
        'meme': {
          id: 'meme',
          name: 'Meme',
          cities: ['Kumba', 'Muyuka']
        }
      }
    },
    'ouest': {
      id: 'ouest',
      name: 'Ouest',
      code: 'WES',
      days: '7 days',
      departments: {
        'haut_nkam': {
          id: 'haut_nkam',
          name: 'Haut-Nkam',
          cities: ['Bafoussam', 'Bangangté', 'Dschang']
        },
        'mifi': {
          id: 'mifi',
          name: 'Mifi',
          cities: ['Mbouda', 'Foumban']
        }
      }
    },
    'adamawa': {
      id: 'adamawa',
      name: 'Adamawa',
      code: 'ADA',
      days: '10-14 days',
      departments: {
        'mayo_banyo': {
          id: 'mayo_banyo',
          name: 'Mayo Banyo',
          cities: ['Banyo', 'Tibati']
        },
        'djoum': {
          id: 'djoum',
          name: 'Djoum',
          cities: ['Ngaoundéré', 'Meiganga']
        }
      }
    },
    'extreme_nord': {
      id: 'extreme_nord',
      name: 'Extrême-Nord',
      code: 'EN',
      days: '10-14 days',
      departments: {
        'diamare': {
          id: 'diamare',
          name: 'Diamaré',
          cities: ['Maroua', 'Mokolo', 'Kousséri']
        },
        'mayo_danay': {
          id: 'mayo_danay',
          name: 'Mayo Danay',
          cities: ['Mora', 'Moulvoudaye']
        }
      }
    },
    'nord': {
      id: 'nord',
      name: 'Nord',
      code: 'NOR',
      days: '10-14 days',
      departments: {
        'mayo_rey': {
          id: 'mayo_rey',
          name: 'Mayo Rey',
          cities: ['Garoua', 'Poli', 'Tcholliré']
        },
        'benoue': {
          id: 'benoue',
          name: 'Bénoué',
          cities: ['Guider', 'Rey Bouba']
        }
      }
    },
    'est': {
      id: 'est',
      name: 'Est',
      code: 'EST',
      days: '10-14 days',
      departments: {
        'lom_et_djerem': {
          id: 'lom_et_djerem',
          name: 'Lom et Djerem',
          cities: ['Bertoua', 'Bélabo']
        }
      }
    },
    'sud': {
      id: 'sud',
      name: 'Sud',
      code: 'SUD',
      days: '7 days',
      departments: {
        'dja_et_lobo': {
          id: 'dja_et_lobo',
          name: 'Dja et Lobo',
          cities: ['Ebolowa', 'Ambam', 'Kribi']
        },
        'mvila': {
          id: 'mvila',
          name: 'Mvila',
          cities: ['Mvangan', 'Olamzé']
        }
      }
    }
  }
};

// ============================================
// FONCTIONS D'ACCÈS AUX DONNÉES
// ============================================

export const getRegions = () => {
  return Object.values(CAMEROON_DATA.regions).map(({ id, name, code, days }) => ({
    id, name, code, days
  }));
};

export const getRegionById = (regionId) => {
  const region = CAMEROON_DATA.regions[regionId];
  if (!region) return null;
  const { id, name, code, days, departments } = region;
  return { id, name, code, days, departments };
};

export const getDepartments = (regionId) => {
  const region = CAMEROON_DATA.regions[regionId];
  if (!region) return [];
  return Object.values(region.departments).map(dept => ({
    id: dept.id,
    name: dept.name,
    cities: dept.cities
  }));
};

export const getCities = (regionId, departmentId) => {
  const region = CAMEROON_DATA.regions[regionId];
  if (!region) return [];
  const department = region.departments[departmentId];
  if (!department) return [];
  return department.cities;
};

export const getCitiesByRegion = (regionId) => {
  const region = CAMEROON_DATA.regions[regionId];
  if (!region) return [];
  const allCities = [];
  Object.values(region.departments).forEach(dept => {
    allCities.push(...dept.cities);
  });
  return allCities;
};